import { render, staticRenderFns } from "./prodorderInputList.vue?vue&type=template&id=059398d9&"
import script from "./prodorderInputList.vue?vue&type=script&lang=js&"
export * from "./prodorderInputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports